// import { createBrowserHistory } from 'history';
// export const browserHistory_ = createBrowserHistory();

import { browserHistory } from 'react-router';
export const browserHistory_ = browserHistory;


// WEBPACK FOOTER //
// ./source/js/browser-history.ts